<template>
  <v-card :width="256">
    <EditScreenDialog ref="editDialog" />
    <EditButtonDialog ref="editButtonDialog" />

    <v-toolbar flat class="card-bar">
      <v-spacer />
      <v-btn icon @click="openEditDialog">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <OMenuButton :menuOpts="menuOpts" />
    </v-toolbar>

    <div class="theGrid">
      <div class="screenIndex">
        {{ index.toString().padStart(2, '0') }}
      </div>
      <div class="screenLine1">
        {{ value.line0 | printSpaces }}
      </div>
      <div class="screenLine2">
        {{ value.line1 | printSpaces }}
      </div>
      <div v-for="(b, index) in buttons" :key="index">
        <v-btn
          tile
          block
          @click="openEditButtonDialog(b.code)"
          :color="b.color"
        >
          <v-icon>{{ b.icon }}</v-icon>
        </v-btn>
      </div>
    </div>

    <v-card-text>
      <div class="tag-list">
        <span class="tag" v-if="value.isDynamic"
          >Dinâmica {{ strDynamic }}</span
        >
        <span class="tag" v-if="value.isOneLiner">One-liner</span>
        <span class="tag">{{ value.backlight | translateBacklight }}</span>
        <span class="tag">{{ value.func | translateFunc }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { translateBacklight, translateFunc, translateVar } from './screen-opts'

const btnOrder = [
  '0x01',
  '0x02',
  '0x03',
  '0x00',
  '0x04',
  '0x05',
  '0x06',
  '0x0a',
  '0x07',
  '0x08',
  '0x09',
  '0x0b'
]

function getIcon(x) {
  x = parseInt(x, 16)
  let icon = `mdi-numeric-${x}`
  if (x == 10) icon = 'mdi-check'
  if (x == 11) icon = 'mdi-close'
  return icon
}

function clone(x) {
  return JSON.parse(JSON.stringify(x))
}

export default {
  components: {
    EditScreenDialog: require('./EditScreenDialog.vue').default,
    EditButtonDialog: require('./EditButtonDialog.vue').default
  },
  props: {
    value: { required: true },
    index: { type: Number, required: true },
    allScreens: { type: Array, required: true }
  },
  computed: {
    buttons() {
      return btnOrder.map(code => {
        let existing = this.value.buttons && this.value.buttons[code]
        let icon = getIcon(code)
        if (existing == null) {
          return { code, icon, color: null }
        } else {
          let hasActions = existing.actions && existing.actions.length > 0
          return { code, icon, color: hasActions ? 'grey' : null }
        }
      })
    },
    menuOpts() {
      return [
        {
          icon: 'mdi-hexadecimal',
          text: 'Ver Hex',
          onClick: () =>
            this.$emit('preview', { type: 'screen', obj: this.value })
        },
        {
          icon: 'mdi-cursor-move',
          text: 'Mover...',
          onClick: () => this.maybeMove()
        },
        {
          icon: 'mdi-content-copy',
          text: 'Duplicar',
          onClick: () => this.$emit('duplicate')
        },
        {
          icon: 'mdi-delete',
          text: 'Excluir',
          onClick: () => this.$emit('remove')
        }
      ]
    },
    strDynamic() {
      let result = []
      for (let v of [0, 1, 2]) {
        let hexCode = this.value['var' + v]
        if (hexCode != null) result.push(`Var ${v}: ${translateVar(hexCode)}`)
      }
      return result.join(', ')
    }
  },
  methods: {
    async openEditDialog() {
      let data = await this.$refs.editDialog.open(this.value)
      if (data != null) {
        this.$emit('update', data)
      }
    },
    async openEditButtonDialog(btnCode) {
      let button = this.value.buttons && this.value.buttons[btnCode]
      if (button == null) button = { code: btnCode }
      let res = await this.$refs.editButtonDialog.open(button, this.allScreens)

      if (res != null) {
        if (this.value.buttons == null) this.$set(this.value, 'buttons', {})
        this.value.buttons[btnCode] = res
        this.$emit('update', clone(this.value))
      }
    },

    async maybeMove() {
      let newIndex = await this.$prompt({
        label: 'Informe o índice para posicionar esta tela.',
        value: this.index.toString()
      })

      if (newIndex != null) {
        this.$emit('move', { newIndex: +newIndex })
      }
    }
  },
  filters: {
    translateBacklight,
    translateFunc,
    printSpaces(s) {
      if (s == null) s = ''
      s = s.padEnd(16, ' ')
      return s.replaceAll(' ', '·')
    }
  }
}
</script>

<style lang="sass">
.theGrid
  display: grid
  grid-template-columns: 64px 64px 64px 64px
  grid-template-rows: 24px 24px 38px 38px 38px
  grid-template-areas: "index t1 t1 t1" "index t2 t2 t2" "b1 b2 b3 b0" "b4 b5 b6 b10 b7 b8 b9 b11"

.screenLine1,
.screenLine2
  grid-column-end: span 3
  font-family: monospace

.screenIndex
  grid-row-end: span 2
  font-family: monospace
  line-height: 48px

.theGrid > *
  place-self: stretch
  border: 1px solid #eee
  text-align: center
</style>
